module.exports = __webpack_public_path__ + "img/at.52391ed8.svg";